import { Link } from 'gatsby';
import React from 'react';
import Layout from '../../components/layout/layout';

import { ImagesBMWM5 } from '../../Images';

const BMWM5: React.FC = () => {
    return (
        <Layout
            title="BMW M5 - WrapTown - profesjonalne oklejanie
        samochodów"
            desc="Zmiana koloru auta folią 3M Satin Black, sprawdź sam jak wygląda nasza oferta oklejania aut."
            url="https://wraptown.pl/realizacje/bmw-m5"
            type="article"
        >
            <main className="px-4 max-w-7xl mx-auto pt-20 pb-20 lg:px-6">
                <div className="mb-10">
                    <p>
                        <Link to="/">Home</Link> /{' '}
                        <Link to="/realizacje">Realizacje</Link> / BMW M5
                    </p>
                </div>
                <div className="text-center">
                    <h3>Zmiana koloru auta</h3>
                    <h1 className="text-4xl mb-6 font-extrabold text-black xl:text-5xl leading-tight xl:leading-snug">
                        BMW M5 - WrapTown
                    </h1>

                    <div className="grid grid-flow-row gap-4 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
                        {ImagesBMWM5.map((image) => {
                            return (
                                <div>
                                    <img
                                        key={image.id}
                                        src={image.href}
                                        alt={image.alt}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>
            </main>
        </Layout>
    );
};

export default BMWM5;
